import React, { useState } from "react";
import { Nav, NavItem, NavLink, Row, Col } from "reactstrap";
import ThreadsList from "./ThreadsList";
import PeopleList from "./PeopleList";

export default function LeftColumn({ meEmail, presenceMap, onOpenThread }) {
  const [tab, setTab] = useState("chats");
  return (
    <>
      
      <Row className="m-0 px-2">
        <Col md="12" className="text-center py-3 px-1 border-bottom border-gray ">
          <img
            style={{width:"200px"}}
            alt="..."
            src={require("../../assets/img/brand/PrepTalk-logo.png")}/>
        </Col>
        
        

        <Col className=" my-1 px-1">
          <button className={`btn w-100 font-weight-bold d-flex justify-content-center align-items-center ${tab==="chats"?"btn-primary":"btn-outline-primary"}`} onClick={e=>{e.preventDefault();setTab("chats");}}><i class="fas fa-envelope text-lg"></i>&nbsp;Chats</button>
          
          
        </Col>
        <Col className=" my-1 px-1">
          <button className={`btn w-100 font-weight-bold d-flex justify-content-center align-items-center  ${tab==="people"?"btn-primary":"btn-outline-primary"}`} onClick={e=>{e.preventDefault();setTab("people");}}><i class="fas fa-users text-lg"></i>&nbsp;People</button>
        </Col>
     
      </Row>
      <div className="flex-grow-1 overflow-auto">
        {tab === "chats" ? (
          <ThreadsList meEmail={meEmail} presenceMap={presenceMap}
            onSelectThread={(threadRow)=> onOpenThread({ id: threadRow.id, isGroup: !!threadRow.isGroup, name: threadRow.name || null, participantsEmails: threadRow.participantsEmails, viewMode: threadRow.viewMode || "mine" })}/>
        ) : (
          <PeopleList meEmail={meEmail} presenceMap={presenceMap}
            onOpenDM={(threadObj)=> onOpenThread(threadObj)}
            onOpenGroup={(threadObj)=> onOpenThread(threadObj)}
          />
        )}
      </div>
    </>
  );
}
